import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
//  @Injectable()
@Injectable({
  providedIn: 'root',
})

export class AuthInterceptor implements HttpInterceptor {
   constructor(private readonly router: Router) {}

 public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Redirect or show a message for 401 Unauthorized
          this.router.navigate(['/no-access']);
        }
        return throwError(() => error);
      })
    );
  }
}
